import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { UserContext } from "../../App";
import NormalButton from "../shared/NormalButton";
import moment from "moment";
import PerventiveTableRowActions from "./PerventiveTableRowActions";
import apiClient from "../utils/apiClient";

export default function PerventivesTable({ PerventiveVisits, setPerventiveVisits,currentPage=false,pageSize=0 }) {


    const navigate = useNavigate();


    const [closeEditModal, setCloseEditModal] = useState(null);

    const [selectedPerventive, setSelectedPerventive] = useState();
    const [showPerventiveDetails, setShowPerventiveDetails] = useState(false);


    const handleClickPerventiveRow = (Perventive) => {
        navigate(`/ar/preventive-visits/${Perventive?._id}`);
    }

    const handleClickShowPopup = (Perventive) => {
        // setSelectedPerventive(Perventive);
        // setShowPerventiveDetails(true);
    }

    const handleCloseModal = () => {
        setShowPerventiveDetails(false);
    }

    const perventiveVisitStatus = (perventiveVisit) => {
        if(perventiveVisit.quantity - perventiveVisit?.issuedQuantity <= perventiveVisit?.reorderPoint) {
            return <span className="text-danger">إعادة طلب</span>;
        }
        if(perventiveVisit?.issuedQuantity / perventiveVisit?.quantity > 0.75) {
            return <span className="text-warning">وشك على النفاذ</span>;
        } else {
            return <span className="text-success">متوفر</span>;
        }
    } 

    const handleShowPerventiveDetails = (perventiveVisit) => {
        setSelectedPerventive(perventiveVisit);
        setShowPerventiveDetails(true);
    }

    const handleClickEditPerventive = () => {
        navigate(`/ar/preventive-visits/edit/${selectedPerventive?._id}`);
    }


    const getFieldName = (field) => {
        switch(field) {
            case 'air-conditioning':
                return 'التكييف';
            case 'plumbing':
                return 'السباكة';
            case 'electrical':
                return 'الكهرباء';
            case 'elevators':
                return 'المصاعد';
            case 'fire & safety':
                return 'الأمن و السلامة';
            default:
                return '';
        }
    }

    const getStatus = (nextDate) => {
        const diff = moment(nextDate).diff(moment(), 'days');
        if(diff === 0) {
            return <span className="text-[14px] font-[600] text-orange">اليوم</span>;
        } else if(diff > 1 && diff < 7) {
            return <span className="text-[14px] font-[600] text-success">بعد {diff} ايام</span>;
        } else if(diff >= 7) {
            return <span className="text-[14px] font-[600] text-blue">مجدولة</span>;
        } else if (diff < 0) {
            return <span className="text-[14px] font-[600] text-danger">منتهية</span>;
        }

        return diff;
    }

    const handleChangeNextScheduleDate = async (id,nextScheduleDate) => {
        try {
        const response = await apiClient.put(`/b-preventive-visits/${id}`,{nextScheduleDate: nextScheduleDate});
        if(response?.data) {
            const updatedPerventive = [...PerventiveVisits];
            const index = updatedPerventive.findIndex(perventive => perventive?._id === id);
            updatedPerventive[index].nextScheduleDate = nextScheduleDate;
            setPerventiveVisits(updatedPerventive);
            setCloseEditModal(response?.data?._id);
        } else {

        }
      } catch(err) {}
    }

    return (
        <>
        <div className="">
            <table className="w-full mt-[30px]" dir="rtl">
                <thead>
                <tr className="border-b-[2px] border-b-grey-50">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 whitespace-nowrap">الوحدة </th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 whitespace-nowrap">الأصل </th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 whitespace-nowrap">الخدمة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 whitespace-nowrap">الكمية</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 whitespace-nowrap">معدل التكرار</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 whitespace-nowrap">الزيارة القادمة</th>
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px] whitespace-nowrap">حالة الطلب</th>
                    {/* <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">أنشئ بواسطة</th> */}
                    {/* <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">التقارير</th> */}
                    {/* <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px]"></th> */}
                </tr>
                </thead>
                <tbody>
                {PerventiveVisits.map((Perventive, index) => {;
                    return (
                    <tr key={`perventiveVisit-${index}`} className={`${index !== PerventiveVisits?.length-1 && 'border-b-[1px] border-b-grey-200'}`}>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] ${index === PerventiveVisits?.length-1 && 'rounded-br-[8px]'}`}>{Perventive?.id}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap`}>{Perventive?.selectedUnit}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap`}>{Perventive?.asset}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap`}>{Perventive?.mainService}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap`}>{Perventive?.qty}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap`}>{Perventive?.freq}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap`}>{moment(Perventive?.startDate).format('DD MMM YYYY')}</td>
                         <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap w-[48px] ${index === PerventiveVisits?.length-1 && 'rounded-bl-[8px]'}`}><span className="text-blue">نشط</span></td>
                        {/* <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer ${index === PerventiveVisits?.length-1 && 'rounded-br-[8px]'}`} onClick={()=>handleClickPerventiveRow(Perventive)}>{currentPage ? ((currentPage-1)*pageSize) + (index+1) : index+1}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickPerventiveRow(Perventive)}>{moment(Perventive?.nextScheduleDate).diff(moment(), 'days') < 0 ? '-' : moment(Perventive?.nextScheduleDate).format('DD MMM YYYY')}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickPerventiveRow(Perventive)}>{Perventive?.createdBy?.name}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickPerventiveRow(Perventive)}>{Perventive?.units[0]?.name} <span className="text-grey-500 font-[400] text-[14px]">{`(${Perventive?.units[0]?.property?.name})`}</span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickPerventiveRow(Perventive)}>{getFieldName(Perventive?.field)}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickPerventiveRow(Perventive)}>{Perventive?.reportsNumber}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickPerventiveRow(Perventive)}><span className="font-[600]" dir="ltr">{getStatus(Perventive?.nextScheduleDate)}</span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap w-[48px] ${index === PerventiveVisits?.length-1 && 'rounded-bl-[8px]'}`} onClick={()=>handleClickShowPopup(Perventive)}>
                            <PerventiveTableRowActions id={Perventive?._id} hasReports={Perventive?.reportsNumber > 0} nextScheduleDate={Perventive?.nextScheduleDate} handleChangeNextScheduleDate={handleChangeNextScheduleDate} closeEditModal={closeEditModal} />
                        </td> */}
                    </tr>
                    )
                })}
                </tbody>
            </table> 
        </div>

          {/* { showPerventiveDetails && <PerventiveModal handleCloseModal={handleCloseModal}>
            <div className="">
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] px-[16px]">
                    <span className="text-[12px] text-grey-900 font-[600]">الاسم:</span> {selectedPerventive?.itemName}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الكود:</span> {selectedPerventive?.itemCode}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الفئة:</span> {PerventiveCategoriesOptions[PerventiveCategoriesOptions.findIndex(option => option?.value === selectedPerventive?.category)]?.label}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">مكان التخزين:</span> {selectedPerventive?.storageLocation}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الكمية لكلية:</span> {selectedPerventive?.quantity}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الكمية المستخدمة:</span> {selectedPerventive?.issuedQuantity}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الحالة:</span> {perventiveVisitStatus(selectedPerventive)}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">أقل عدد مخزون لإعادة الطلب:</span> {selectedPerventive?.reorderPoint}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">معلومات المورد:</span> {selectedPerventive?.supplierInfo}
                </div>
                <div className="text-end p-[16px]">
                    <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleCloseModal}>إلغاء</div>
                    <NormalButton label={'تعديل المخزون'} onClick={handleClickEditPerventive} />
                </div>
            </div>
        </PerventiveModal> } */}

        </>
    )
}

